<template>
    <div class="top10-drink-bar-chart">
        <div class="title">{{$t('yin_pin_bang_dan')}} Top10</div>
        <div class="chart" id="top10DrinkBarChart">

        </div>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import bar from './bar'
    import {orderDrinkTop10} from '@/api/delivery/order/order'
    export default {

        data() {
            return {
                bar,
                myChart: null,
            }
        },
        methods: {
            init(){
                this.myChart = echarts.init(document.getElementById('top10DrinkBarChart'));
                this.bar.xAxis.data = []
                this.bar.series[0].data = []
                orderDrinkTop10().then(res => {
                    for (let i = (res.data||[]).length - 1; i >= 0; i--) {
                        this.bar.xAxis.data.push(res.data[i].name)
                        this.bar.series[0].data.push(res.data[i].account)
                    }
                    this.myChart.setOption(this.bar)
                    this.chartSelect()
                    let vue= this
                    window.onresize = function () {
                        vue.myChart.resize()
                    }
                })
            },
            chartSelect () {
                let chart = this.myChart;
                let data = this.bar.series[0].data
                var hourIndex = 0;
                var fhourTime = null;
                fhourTime = setInterval(function () {
                    chart.dispatchAction({
                        type: "downplay",
                        seriesIndex: 0,

                    });
                    chart.dispatchAction({
                        type: "highlight",
                        seriesIndex: 0,
                        dataIndex: hourIndex
                    });
                    chart.dispatchAction({
                        type: "showTip",
                        seriesIndex: 0,
                        dataIndex: hourIndex
                    });
                    hourIndex++;
                    if (hourIndex > data.length) {
                        hourIndex = 0;
                    }
                }, 2000);
                //鼠标移入停止轮播
                chart.on("mousemove", function (e) {
                    clearInterval(fhourTime)
                    chart.dispatchAction({
                        type: "downplay",
                        seriesIndex: 0,
                    });
                    chart.dispatchAction({
                        type: "highlight",
                        seriesIndex: 0,
                        dataIndex: e.dataIndex
                    });
                    chart.dispatchAction({
                        type: "showTip",
                        seriesIndex: 0,
                        dataIndex: e.dataIndex
                    });
                })
                //鼠标移出恢复轮播
                chart.on("mouseout", function () {
                    fhourTime = setInterval(function () {
                        chart.dispatchAction({
                            type: "downplay",
                            seriesIndex: 0,

                        });
                        chart.dispatchAction({
                            type: "highlight",
                            seriesIndex: 0,
                            dataIndex: hourIndex
                        });
                        chart.dispatchAction({
                            type: "showTip",
                            seriesIndex: 0,
                            dataIndex: hourIndex
                        });
                        hourIndex++;
                        if (hourIndex > data.length) {
                            hourIndex = 0;
                        }
                    }, 3000);
                })
            }
        },

        mounted() {
            let vue = this
            setTimeout(function () {
                vue.init()
            }, 200)
        },
        beforeDestroy () {
            this.myChart.clear()
        },
        watch: {
            series(){

            }
        }
    }
</script>

<style lang="scss">
    .top10-drink-bar-chart {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .title {
            height: 72px;
            line-height: 72px;
            padding-left: 16px;
            color: $f_th_color;
            font-weight: 500;
            border-bottom: 1px solid $border_color;
        }
        .chart {
            flex: 1;
            width: 100%;
        }
    }
</style>
